import { useCallback } from 'react';
import { TServerSendRequest } from 'js/hooks/socket/types';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetGameZoneCollection = () => {
    const send = useGenericSend();

    return useCallback(async () => {
        const { data: { games } } = await send<TServerSendRequest, Types.IGetGameZoneCollectionResponseData>({
            ID: 35216,
            responses: [35217, 35218],
            description: 'Get Game Zone Collection'
        });

        return { games };
    }, [send]);
};
